import React, { useCallback } from 'react';
import { observer } from 'mobx-react';
import { getContainingView } from '@jbrowse/core/util';
import BaseDisplayComponent from '../../shared/BaseDisplayComponent';
const Arcs = observer(function ({ model, }) {
    const view = getContainingView(model);
    const width = Math.round(view.dynamicBlocks.totalWidthPx);
    const height = model.height;
    const cb = useCallback((ref) => {
        model.setRef(ref);
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [model, width, height]);
    // note: the position absolute below avoids scrollbar from appearing on track
    return (React.createElement("canvas", { "data-testid": "arc-canvas", ref: cb, style: { width, height, position: 'absolute' }, width: width * 2, height: height * 2 }));
});
const LinearReadArcsReactComponent = observer(function ({ model, }) {
    return (React.createElement(BaseDisplayComponent, { model: model },
        React.createElement(Arcs, { model: model })));
});
export default LinearReadArcsReactComponent;
